import { render, staticRenderFns } from "./shootingDistribution_expectedGoal_scatter.vue?vue&type=template&id=4e73207d&scoped=true"
import script from "./shootingDistribution_expectedGoal_scatter.vue?vue&type=script&lang=js"
export * from "./shootingDistribution_expectedGoal_scatter.vue?vue&type=script&lang=js"
import style0 from "./shootingDistribution_expectedGoal_scatter.vue?vue&type=style&index=0&id=4e73207d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e73207d",
  null
  
)

export default component.exports